import React, { useEffect, useRef } from 'react';

import { store } from 'redux/store';
import { setCurrentTab } from 'redux/reducers/meteorologyFieldsLayoutReducer';
import MeteorologyFieldsDisplay from 'components/Meteorology/Fields/Display';
import HeatmapDisplay from 'components/Meteorology/Fields/HeatmapDisplay';
import DisplayTitleBar from 'components/Meteorology/Fields/DisplayTitleBar';
import ImageDownloadButton from 'components/Meteorology/Fields/ImageDownloadButton';
import QueryErrorState from 'components/DesignSystem/QueryErrorState';
import ObservedDataMobile from 'components/Meteorology/Fields/ObservedData/Mobile';
import useObservedDataControlPanel from 'utils/hooks/meteorology/useObservedDataControlPanel';
import useObservedDataImagesDownload from 'utils/hooks/meteorology/observedData/useImagesDownload';
import useImageRowSize from 'utils/hooks/meteorology/useImageRowSize';
import useIsMobile from 'utils/hooks/useIsMobile';
import buildImageDisplayData from 'helper/products/observedData/buildImageDisplayData';

export default function ObservedData() {
  useEffect(() => {
    store.dispatch(setCurrentTab('observeddata'));
  }, []);
  const {
    obsBase64,
    climatologyBase64,
    anomalyBase64,
    heatmapBase64,
    imagesAreFetching,
    alerts,
    isConsultedHeatmap,
    queryTrigger,
  } = useObservedDataControlPanel();
  const { imageSets, columnLabels, rowLabels } = buildImageDisplayData({
    observedData: obsBase64,
    climatology: climatologyBase64,
    anomaly: anomalyBase64,
  });
  const { rowSize, setRowSize } = useImageRowSize();
  const initialRowSize = useRef(rowSize);
  const isMobile = useIsMobile();

  useEffect(() => () => { setRowSize(initialRowSize.current); }, [setRowSize]);

  useEffect(() => {
    if (columnLabels.length) setRowSize(columnLabels.length);
  }, [setRowSize, columnLabels.length]);

  const queryError = alerts.length > 0 ? alerts[0] : undefined;

  const { onDownloadClick, downloadDisabled } = useObservedDataImagesDownload(
    {
      observedData: obsBase64,
      climatology: climatologyBase64,
      anomaly: anomalyBase64,
      heatmap: heatmapBase64,
    },
    isConsultedHeatmap,
    imagesAreFetching,
  );

  if (isMobile) {
    return <ObservedDataMobile />;
  }

  function renderContent() {
    if (queryError) {
      return (
        <QueryErrorState
          title={queryError.title}
          message={queryError.message}
          onRetry={queryTrigger}
        />
      );
    }
    if (isConsultedHeatmap) {
      return <HeatmapDisplay base64={heatmapBase64} fetching={imagesAreFetching} />;
    }
    return (
      <MeteorologyFieldsDisplay
        imageSets={imageSets}
        columnLabels={columnLabels}
        rowLabels={rowLabels}
        fetchingImages={imagesAreFetching}
      />
    );
  }

  return (
    <div className="observed-data-display">
      <DisplayTitleBar tab="observedData">
        {/*
          Escondido no erro, nao apenas desabilitado: uma consulta que falha nao
          limpa as figuras da consulta anterior, entao o botao ficaria ativo
          oferecendo imagens que nao estao mais na tela.
        */}
        {!queryError && (
          <ImageDownloadButton onClick={onDownloadClick} disabled={downloadDisabled} />
        )}
      </DisplayTitleBar>
      <div className="mb-4">
        {renderContent()}
      </div>
    </div>
  );
}
